/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

export const DateContext = createContext();
